import React, {useEffect} from 'react';
import {getPathMapping} from "../utils/getPathMapping";
import {Route, Routes} from "react-router-dom";
import NotFoundPage from "../components/pageRelated/NotFoundPage";
import {WikiPage} from "../components/wiki/WikiPage";
import BlogLayout from "../components/pageRelated/BlogLayout";
import {AboutPage} from "../pages/meta/AboutPage";
import {BlogPostWrapper} from "../components/pageRelated/BlogPostWrapper";
import TagIndexPageWrapper from "../components/pageRelated/TagIndexWrapper";
import TagPageWrapper from "../components/pageRelated/tags";
import {StatistikSchlüssel} from "../pages/uni/statistik_schlüssel";
import {EkvvCollision} from "../pages/Ekvv-Collision";
import {EkvvStudierbarkeit} from "../pages/EkvvStudierbarkeit";
import {IGEMData} from "../pages/igem/iGEMData";
import {TemplateWikiDocu} from "../pages/igem/TemplateWikiDocu";
import {NavBarContent} from "../routes/navBarContent";
import {PartTableDocu} from "../pages/igem/template-wiki-docu/PartTableDocu";
import {ProtocolDocu} from "../pages/igem/template-wiki-docu/ProtocolDocu";
import {PlasmidViewerConverter} from "../pages/igem/PlasmidViewerConverter";
import {AutomaticSidebarDocu} from "../pages/igem/template-wiki-docu/AutomaticSidebarDocu";
import {CommunityBlackboardFlyerDocu} from "../pages/igem/template-wiki-docu/CommunityBlackboardFlyerDocu";
import {HPOverviewWithTimeline} from "../pages/igem/template-wiki-docu/HPOverviewWithTimeline";
import {InstaPostDocu} from "../pages/igem/template-wiki-docu/InstaPostDocu";
import {PlasmidViewerDocu} from "../pages/igem/template-wiki-docu/PlasmidViewerDocu";
import {EngineeringCycleCarouselStyleDocu} from "../pages/igem/template-wiki-docu/EngineeringCycleCarouselStyleDocu";
import {CompatibleFigureDocu} from "../pages/igem/template-wiki-docu/CompatibleFigureDocu";

const App = () => {

    const pathMapping = getPathMapping(NavBarContent);
    const currentPath =
        window.location.pathname || "/";

    // Set Page Title
    const title =
        currentPath in pathMapping ? pathMapping[currentPath].title : "Not Found";

    useEffect(() => {
        document.title = `Liliana Sanfilippo`;
    }, [title]);

    return (
        <div id={"main-wrapper"}>
            <div className={"flex flex-row"}>
                {/* <div className={"sidebarbox hidden md:block xl:block md:w-2/12 xl:w-2/12"}>

                            <Sidebar/>

                        </div> */}
                <div className={"w-full md:w-9/12 xl:w-9/12 mx-auto"}>
                    <BlogLayout>
                        <Routes>
                            {/* Posts */}
                            <Route path="/posts/:slug" element={<BlogPostWrapper/>}/>

                            {/* Misc NavigationBar */}
                            {/* <Route path="/tags" element={<TagsPage />} />*/}
                            <Route path="/home" element={<AboutPage/>}/>
                            <Route path={"/"} element={<AboutPage/>}/>
                            <Route path={""} element={<AboutPage/>}/>

                            {Object.entries(pathMapping).map(([path, {component: Component}], index) => (
                                    <Route key={index} path={path} element={Component}/>
                                )
                            )
                            }

                            <Route path={`${process.env.REACT_APP_UNI_PATH}/learning-materials/wts/schlüssel`} element={<StatistikSchlüssel/>} />

                            <Route path={`${process.env.REACT_APP_COUNSELLING_SYSTEM}/tools/ekvv-collision-check`} element={<EkvvCollision/>} />
                            <Route path={`${process.env.REACT_APP_COUNSELLING_SYSTEM}/tools/ekvv-studierbarkeit`} element={<EkvvStudierbarkeit/>} />

                            <Route path={`${process.env.REACT_APP_IGEM_PATH}/data`} element={<IGEMData/>} />
                            <Route path={process.env.REACT_APP_IGEM_TEMPLATE_WIKI_PATH} element={<TemplateWikiDocu/>} />
                            <Route path={`${process.env.REACT_APP_IGEM_TEMPLATE_WIKI_PATH}/part-table`} element={<PartTableDocu/>} />
                            <Route path={`${process.env.REACT_APP_IGEM_TEMPLATE_WIKI_PATH}/plasmid-viewer-converter`} element={<PlasmidViewerConverter/>} />
                            <Route path={`${process.env.REACT_APP_IGEM_TEMPLATE_WIKI_PATH}/automatic-sidebar`} element={<AutomaticSidebarDocu/>} />
                            <Route path={`${process.env.REACT_APP_IGEM_TEMPLATE_WIKI_PATH}/blackboard-flyer`} element={<CommunityBlackboardFlyerDocu/>} />
                            <Route path={`${process.env.REACT_APP_IGEM_TEMPLATE_WIKI_PATH}/protocols-sorted`} element={<ProtocolDocu/>} />
                            <Route path={`${process.env.REACT_APP_IGEM_TEMPLATE_WIKI_PATH}/hp-overview-with-timeline`} element={<HPOverviewWithTimeline/>} />
                            <Route path={`${process.env.REACT_APP_IGEM_TEMPLATE_WIKI_PATH}/instagram-post`} element={<InstaPostDocu/>} />
                            <Route path={`${process.env.REACT_APP_IGEM_TEMPLATE_WIKI_PATH}/plasmid-viewer`} element={<PlasmidViewerDocu/>} />
                            <Route path={`${process.env.REACT_APP_IGEM_TEMPLATE_WIKI_PATH}/figure-automatic`} element={<CompatibleFigureDocu/>} />
                            <Route path={`${process.env.REACT_APP_IGEM_TEMPLATE_WIKI_PATH}/engineering-cycle-1`} element={<EngineeringCycleCarouselStyleDocu/>} />


                            <Route path={`${process.env.REACT_APP_REACT_REFERENCE_MANAGER_PATH}/:pageName`}
                                   element={<WikiPage folder={"wiki"}/>}/>
                            <Route path={`${process.env.REACT_APP_REACT_REFERENCE_GENERATOR_PATH}/:pageName`}
                                   element={<WikiPage folder={"wiki-generator"}/>}/>
                            <Route path={`${process.env.REACT_APP_REACT_BIBTEX_PARSER_PATH}/:pageName`}
                                   element={<WikiPage folder={"wiki-parser"}/>}/>
                            <Route path={`${process.env.REACT_APP_REACT_AUTHOR_PARSER_PATH}/:pageName`}
                                   element={<WikiPage folder={"wiki-author"}/>}/>
                            <Route path={`${process.env.REACT_APP_UNI_PATH}/learning-materials/:pageName`}
                                   element={<WikiPage folder={"uni"}/>}/>
                            <Route path={`${process.env.REACT_APP_IGEM_BIELEFELD_PATH}/:pageName`}
                                   element={<WikiPage folder={"igemnotes"}/>}/>
                            <Route path={"/other/:pageName"}
                                   element={<WikiPage folder={"other"}/>}/>

                            {/* Tag Index Page */}
                            <Route path={process.env.REACT_APP_TAG_ROOT} element={<TagIndexPageWrapper/>}/>


                            {/* Tag NavigationBar */}
                            <Route path={`${process.env.REACT_APP_TAG_ROOT}/:tag`} element={<TagPageWrapper/>}/>

                            {/* Fallback 404 */}
                            <Route path="*" element={<NotFoundPage/>}/>
                        </Routes>
                    </BlogLayout>
                </div>
            </div>

        </div>
    );
}

export default App;
